import React, { useState, useEffect, useMemo } from "react";
import LegendColor from "../Atom/LegendColor";
import BackendPaginatedDataTable from "../Atom/BackendPaginatedDataTable";
import SectionHeader from "../Atom/SectionHeader";
import _ from "lodash";
import TileCard from "../Atom/Cards/TileCard";

const BackendTableWizard = ({
	sectionHeading,
	buttonName,
	onButtonClick,
	onButtonLoading = false,
	setSearchFunction,
	search,
	rowData,
	columns,
	noDataComponent,
	totalCount,
	handlePerRowsChange,
	handlePageChange,
	onRowClicked,
	onProgress,
	selectableRows,
	setCheckboxArray,
	clearSelectedRows,
	selectableRowDisabled,
	conditionalRowStyles,
	legendColors,
	isFilter,
	getDataFunction,
	perPage,
	eventId,
	filterParams,
	setFilterParams,
	onSort,
	sortServer,
	overflowY,
	showUploadAttendees,
	refreshData,
	refreshDataLoading,
	BulkActions,
	selectableRowSelected,
	onCallFunction,
	paginationPerPage,
	pagination,
	paginationServer,
	paginationRowsPerPageOptions,
	headerMargin,
	refreshHeaderComponent,
	tempData = false,
	hideSectionHeader,
	prop = {},
	bulkUploadDetails = {},
	listOfCustomCheckins = [],
	handleDropdownSelect,
	selectedDropdownOption,
	dropdownOptions,
	isDefault = false,
	checkinId = false,
	filterTilesArray = [],
	setSelectedTileId,
	selectedTileId,
	statusCounts = {}, // store status counts
	setWaitlistStatus = ""
}) => {
	return (
		<div>
			{/* Header - Title, searchbar, and Launch button */}
			{!hideSectionHeader && (
				<SectionHeader
					tempData={tempData}
					heading={sectionHeading}
					refreshData={refreshData}
					refreshDataLoading={refreshDataLoading}
					disabledButton={(_.isEmpty(rowData) || prop?.eventInfo?.organiser_role_id === 4) ? true : false}
					onButtonLoading={onButtonLoading}
					setSearchFunction={setSearchFunction}
					search={search}
					buttonName={buttonName}
					onButtonClick={onButtonClick}
					isFilter={isFilter}
					getDataFunction={getDataFunction}
					perPage={perPage}
					eventId={eventId}
					filterParams={filterParams}
					setFilterParams={setFilterParams}
					showUploadAttendees={showUploadAttendees}
					onCallFunction={onCallFunction}
					headerMargin={headerMargin}
					refreshHeaderComponent={refreshHeaderComponent}
					prop={prop}
					bulkUploadDetails={bulkUploadDetails}
					listOfCustomCheckins={listOfCustomCheckins}
					handleDropdownSelect={handleDropdownSelect}
					selectedDropdownOption={selectedDropdownOption}
					dropdownOptions={dropdownOptions}
					tooltipButton={prop?.eventInfo?.organiser_role_id === 4 ? "Your role - Admin (No Downloads) doesn't have the necessary permission to download" : ""}
					{...(isDefault && { isDefault })}
					{...(checkinId && { checkinId })}
				/>
			)}

			{sectionHeading === "Approval Based Registration" && (
				<div className="row mb-4">
					{filterTilesArray.map((tile, index) => (
						<div className="col-3" key={index}>
							<TileCard
								onClick={() => {
									setFilterParams("&waitlist_status=" + tile?.id)
									setWaitlistStatus("&waitlist_status=" + tile?.id);
									setSelectedTileId(tile?.id);
								}}
								border={selectedTileId === tile?.id ? "2px solid var(--primaryColor)" : ""}
							>
								<p className="mb-2 tile-heading">{tile?.name}</p>
								<p className="mb-0 tile-subtext">{statusCounts[tile?.id] || 0}</p>
							</TileCard>
						</div>
					))}
				</div>
			)}



			{BulkActions}
			{/* Datatable */}
			<BackendPaginatedDataTable
				rowData={rowData}
				columns={columns}
				noDataComponent={noDataComponent}
				totalCount={totalCount}
				handlePerRowsChange={handlePerRowsChange}
				handlePageChange={handlePageChange}
				onRowClicked={onRowClicked}
				onProgress={onProgress}
				selectableRows={selectableRows}
				setCheckboxArray={setCheckboxArray}
				clearSelectedRows={clearSelectedRows}
				selectableRowDisabled={selectableRowDisabled}
				conditionalRowStyles={conditionalRowStyles}
				onSort={onSort}
				sortServer={sortServer}
				overflowY={overflowY}
				paginationPerPag={paginationPerPage}
				pagination={pagination}
				paginationServer={paginationServer}
				paginationRowsPerPageOptions={paginationRowsPerPageOptions}
			/>

			{legendColors && legendColors.length && rowData.length ? (
				<LegendColor legendColors={legendColors} />
			) : (
				""
			)}
			<style>{`
				.tile-heading{
					font-family: Hind;
					font-weight: 400;
					font-size: 14px;
					line-height: 100%;
					letter-spacing: 0%;
					color: var(--primaryColor) !important;
				}
				.tile-subtext{
					font-family: Hind;
					font-weight: 500;
					font-size: 20px;
					line-height: 100%;
					letter-spacing: 0%;
					color: var(--primaryColor) !important;
				}
			`}
			</style>
		</div>
	);
};
export default BackendTableWizard;